import { render, staticRenderFns } from "./cookingCard.vue?vue&type=template&id=5b2e2b40&scoped=true"
import script from "./cookingCard.vue?vue&type=script&lang=js"
export * from "./cookingCard.vue?vue&type=script&lang=js"
import style0 from "./cookingCard.vue?vue&type=style&index=0&id=5b2e2b40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2e2b40",
  null
  
)

export default component.exports